// Lead-attributie (functioneel — geen tracking/advertentie-cookie).
//
// Doel: bij élke formulier-aanvraag weten WAAR de bezoeker vandaan kwam
// (Google organisch, Ads, social, direct, verwijzing) en op WELKE pagina
// hij binnenkwam + verstuurde. Dat wordt meegestuurd in de lead-mail én
// als GA4 'generate_lead'-event, zodat je leads per kanaal/pagina ziet.
//
// First-touch: we slaan de herkomst bij de EERSTE pageview op in
// sessionStorage, zodat interne navigatie de oorspronkelijke bron niet
// overschrijft. sessionStorage = per tab, verdwijnt bij sluiten → puur
// functioneel om de eigen aanvraag te verrijken (geen profilering).

const KEY = 'abc-lead-src';

function isBrowser() {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
}

function deriveBron(referrer, params) {
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  const utmCampaign = params.get('utm_campaign');
  const gclid = params.get('gclid'); // Google Ads click id

  if (gclid || (utmMedium && /cpc|ppc|paid|ads/i.test(utmMedium))) {
    const detail = utmCampaign ? ` (${utmSource || 'google'} / ${utmCampaign})` : ` (${utmSource || 'google ads'})`;
    return `Advertentie${detail}`;
  }
  if (utmSource) return `Campagne: ${utmSource}${utmMedium ? ' / ' + utmMedium : ''}`;

  const ref = (referrer || '').toLowerCase();
  if (!ref) return 'Direct / typte de URL';
  if (/google\./.test(ref)) return 'Google (organisch)';
  if (/bing\./.test(ref)) return 'Bing';
  if (/duckduckgo/.test(ref)) return 'DuckDuckGo';
  if (/facebook|instagram|fb\.com|t\.co|linkedin|x\.com|tiktok/.test(ref)) return 'Social media';
  if (/abcongedierte\.nl/.test(ref)) return 'Interne link';
  try { return `Verwijzing: ${new URL(referrer).hostname}`; } catch { return `Verwijzing: ${referrer}`; }
}

/** Eénmalig bij app-start aanroepen (eerste pageview). Idempotent. */
export function captureLeadSource() {
  if (!isBrowser()) return;
  try {
    if (sessionStorage.getItem(KEY)) return; // first-touch behouden
    const params = new URLSearchParams(window.location.search);
    sessionStorage.setItem(KEY, JSON.stringify({
      bron: deriveBron(document.referrer, params),
      referrer: document.referrer || '',
      landing: window.location.pathname || '/',
      utm: ['utm_source', 'utm_medium', 'utm_campaign']
        .map((k) => params.get(k)).filter(Boolean).join(' / '),
    }));
  } catch { /* sessionStorage geblokkeerd — niet fataal */ }
}

/** Velden voor de lead-mail (worden automatisch in formatEmailBody getoond). */
export function getLeadSourceFields() {
  if (!isBrowser()) return {};
  let s = {};
  try { s = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch { /* */ }
  const huidige = window.location.pathname || '/';
  return {
    Bron: s.bron || 'Direct / typte de URL',
    Landingspagina: s.landing || huidige,
    'Aanvraag vanaf pagina': huidige,
  };
}

/** Compacte versie voor het GA4-event. */
export function getLeadSourceMeta() {
  let s = {};
  if (isBrowser()) {
    try { s = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch { /* */ }
  }
  return {
    lead_source: s.bron || 'Direct',
    landing_page: s.landing || '',
    page_path: isBrowser() ? window.location.pathname : '',
  };
}
